import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/api/cashflow";

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const CashFlowApi = {
  getDiario: async (empresa, year) => {
    const res = await axios.get(`${API_URL}/diario/${empresa}`, {
      params: { year },
      headers: authHeader(),
    });
    return res.data;
  },
};
